const ReviewSuggestedIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <rect width='24' height='24' rx='12' fill='#823A0C' />
      <path
        d='M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z'
        fill='#FFF3D3'
      />
      <circle cx='12' cy='12' r='11' stroke='white' strokeWidth='2' />
    </svg>
  );
};

export default ReviewSuggestedIcon;
